import { Menu } from 'antd';
import type { MenuProps } from 'antd/es/menu';
import { observer } from 'mobx-react-lite';
import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { Module, ModuleRouter } from '@tools/ui/types';
import { moduleStore } from '@tools/ui-stores';
import { theme } from '@tools/ui-utils/theme.util';
import NavigationIcon from '../../common/icons/NavigationIcon.icon';
import PlatformHub from './PlatformHub/PlatformHub.component';

type MenuItem = Required<MenuProps>['items'][number];

const MenuStyled = styled(({ moduleColor, ...props }) => <Menu {...props} />)<{
  moduleColor?: string;
}>`
  border-right: none;
  margin-bottom: auto;
  && .ant-menu-item {
    width: 100%;
    border-radius: 0;
    margin: 0;
    height: 80px;
    padding: 22px calc(50% - 25px / 2) 0;
    &.ant-menu-item-selected {
      background-color: ${theme.colors.sideContainer.backgroundActive};
      & .anticon {
        color: ${({ moduleColor }) => moduleColor || ''};
      }
    }
  }
`;

const NavLinkStyled = styled(NavLink)`
  color: ${theme.colors.white};
`;

type IProps = {
  menuItemsRoute: (Module | ModuleRouter)[];
  selectedKeyRoute: number;
};

const SideMenu: React.FC<React.PropsWithChildren<IProps>> = observer(
  ({ selectedKeyRoute, menuItemsRoute }: IProps) => {
    const { activeModule } = moduleStore;
    const menuItems = useMemo(
      () =>
        menuItemsRoute.map((route, index) => {
          const displayName = (route as ModuleRouter).displayName || route.name;
          return {
            key: index,
            label: (
              <NavLinkStyled to={route.path} data-testid={`${displayName}-menu-item`}>
                {displayName}
              </NavLinkStyled>
            ),
            icon: <NavigationIcon component={route.icon} />,
          };
        }),
      [menuItemsRoute],
    ) as MenuItem[];

    return (
      <>
        <PlatformHub />
        <MenuStyled
          selectedKeys={[`${selectedKeyRoute}`]}
          items={menuItems}
          theme="dark"
          moduleColor={activeModule?.color}
        />
      </>
    );
  },
);

export default SideMenu;
